import { render } from "./PartnerOpportunity.vue?vue&type=template&id=6099da43&scoped=true"
import script from "./PartnerOpportunity.vue?vue&type=script&lang=js"
export * from "./PartnerOpportunity.vue?vue&type=script&lang=js"

import "./PartnerOpportunity.vue?vue&type=style&index=0&id=6099da43&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6099da43"]])

export default __exports__